import { FlashList } from '@shopify/flash-list'
import { withUnistyles } from 'react-native-unistyles'

// withUnistyles loses the generic type parameter of FlashList<T>, so we
// cast the wrapped component back to preserve generics at call sites.
const UniFlashList = withUnistyles(FlashList) as unknown as typeof FlashList

export default UniFlashList
